import React, { useState } from 'react'
import ClassNames from 'classnames'
import { AttachedFileStyle } from './styled'
import { Button, Image, InputUpload, Loaders, Section } from '../../components'
import { ICONS } from '../../themes'
import { checkFileType } from '../../helpers/functions/checkFileType'
import { toastFail } from '../../helpers'
import { updateProgress } from '../../apiService'
import FileDownload from 'js-file-download'
/**
 * AttachedFile description
 * - ...
 */
export const updateProgressFile = (open, percent) => {
  updateProgress({ open, percent, label: 'Loading...' })
}
export class AttachedFile extends React.PureComponent {
  render() {
    const {
      className,
      id = 'upload',
      name = 'upload',
      key,
      onDownload,
      disabled,
      isDisable = false,
      isIcon = true,
      hasRemove,
      onClickRemove,
      hasCheck,
      fileList = [],
      onSelect,
      isDisableInput = false,
      maxFileSizeMb = 50,
      classNameInput,
      classNameFile = 'form-group-attached-file',
      isReadOnly = false,
      isUpload = true,
      isHelp = false,
      loadingDownload = [],
      isShow = true,
    } = this.props

    const onClick = e => {
      e.target.value = null
    }

    const onChange = async e => {
      if (e.target.files && e.target.files.length) {
        let [file] = e.target.files
        if (!(await checkFileType(file))) {
          // toastFail(`File type not allow.`)
          onSelect(null)
        } else if (maxFileSizeMb && file.size / 1000000 > maxFileSizeMb) {
          toastFail(`File size exceeded ${maxFileSizeMb} Mb.`)
          onSelect(null)
        } else {
          e.target.files = null
          onSelect(file, e, () => {}, this.props)
        }
      }
    }

    const isFileDownloading = fileId => {
      return loadingDownload.some(file => file.id === fileId)
    }

    const renderAttachedFile = () => {
      // console.log('FileList', fileList)
      return (
        fileList !== null &&
        fileList.length > 0 &&
        fileList.map(
          (file, key) =>
            !file.is_deleted && (
              <Section className="form-group-attached-file">
                <AttachedFileStyle
                  className={ClassNames(
                    'attached-file',
                    { 'is-disabled': disabled || isDisable },
                    { 'is-icon': isIcon && !isFileDownloading(file.id) },
                    { 'downloading-icon': isFileDownloading(file.id) },
                    className
                  )}
                  key={key}
                  id={'attached-file-' + file.id}
                  title={file.name || file.file_name}
                  disabled={disabled || isDisable}
                >
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="file-link removable"
                    onClick={() => {
                      onDownload(file, file.name ? file.name : file.file_name)
                    }}
                  >
                    <span className="file-name">
                      {file.name || file.file_name}
                    </span>
                  </a>
                  {(hasRemove || hasCheck) && (
                    <Button
                      className="link"
                      onClick={() => onClickRemove(file)}
                    >
                      <Image
                        className="delete-circle-icon"
                        src={ICONS['icon-delete-circle-red.svg']}
                        alt="delete circle"
                      />
                    </Button>
                  )}
                </AttachedFileStyle>
              </Section>
            )
        )
      )
    }

    const renderDownloadFile = file => {
      return (
        loadingDownload.length > 0 &&
        loadingDownload.map((value, index) => {
          if (value.id === file.id) {
            return (
              <Loaders
                load={true}
                key={index}
                style={{
                  marginLeft: '-35px',
                  position: 'relative',
                  right: '-75px',
                }}
              />
            )
          }
        })
      )
    }

    return (
      <>
        {isUpload && (
          <Section
            className="form-group-control"
            style={{ position: 'relative', marginBottom: '0.5em' }}
          >
            <Section className={classNameInput}>
              <InputUpload
                id={id}
                name={name}
                isHideIput={true}
                isDisable={isDisableInput}
                readOnly={isReadOnly}
                browseButtonText="Attach"
                onClick={onClick}
                onChange={onChange}
              />
              {isHelp && (
                <Section className="link tooltip-attachment">
                  <Image
                    src={ICONS['icon-help.svg']}
                    alt="help"
                    tootipValue={`(*File type must be jpg, gif, png, bmp, tif, tiff, pdf, doc, docx, \n xls, xlsx, ppt, pptx, txt and Maximum File Size 50 Mb)`}
                    useTootipFor="FileType"
                    useTootip={true}
                    style={{
                      position: 'center',
                      top: '-10px',
                    }}
                  />
                </Section>
              )}
            </Section>
          </Section>
        )}
        {isShow && renderAttachedFile()}
        {/* <AttachedFileStyle
          className={ClassNames(
            'attached-file',
            { 'is-disabled': disabled || isDisable },
            { 'is-icon': isIcon },
            className
          )}
          key={key}
          id={id}
          title={fileName}
          disabled={disabled || isDisable}
        >
          <a target="_blank" rel="noopener noreferrer" onClick={onClick}>
            <span className="file-name">{fileName}</span>
          </a>
          {(hasRemove || hasCheck) && (
            <Button className="link" onClick={onClickRemove}>
              <Image
                className="delete-circle-icon"
                src={ICONS['icon-delete-circle-red.svg']}
                alt="delete circle"
              />
            </Button>
          )}
        </AttachedFileStyle> */}
      </>
    )
  }
}
